import React from 'react';
import { Check } from 'lucide-react';
import aboutBeforeAfter from '@/assets/about-before-after.jpg';

const features = [
  'Eco-friendly process',
  'Superior surface finish',
  'No surface damage',
  'Fast turnaround times',
];

const AboutSection = () => {
  return (
    <section id="about" className="section-padding bg-background relative">
      <div className="container-wide mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="animate-fade-in-up opacity-0" style={{ animationDelay: '0.2s' }}>
            <p className="text-primary font-medium tracking-[0.3em] uppercase mb-4 text-sm">
              About Us
            </p>
            <h2 className="font-display text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Surface restoration <span className="gradient-text">done right</span>
            </h2>
            <p className="text-lg text-muted-foreground mb-6">
              Based in Islington, Christchurch, we deliver exceptional surface restoration results
              that traditional methods simply cannot achieve. With years of expertise in vapour
              blasting technology, we're the trusted choice for automotive enthusiasts, marine
              businesses, and industrial clients across Canterbury.
            </p>
            <p className="text-lg text-muted-foreground mb-8">
              Our environmentally friendly process uses a precise mixture of water, compressed air,
              and fine media to gently restore surfaces without causing damage or warping. The
              result is a clean, smooth finish that looks like new.
            </p>
            <div className="grid grid-cols-2 gap-4">
              {features.map((feature) => (
                <div key={feature} className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Check className="text-primary w-4 h-4" strokeWidth={3} />
                  </div>
                  <span className="text-foreground">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div
            className="relative rounded-2xl overflow-hidden glass-card hover-lift animate-fade-in-up opacity-0 mx-auto w-[70%] bg-muted/40 animate-pulse"
            style={{ animationDelay: '0.4s' }}
          >
            <img
              src={aboutBeforeAfter}
              alt="Before and after vapour blasting comparison of a carburettor - precision restoration from Christchurch's leading vapour blasting service"
              className="w-full h-full object-cover"
              loading="eager"
              fetchPriority="high"
              decoding="async"
              onLoad={(e) => e.currentTarget.parentElement?.classList.remove('animate-pulse', 'bg-muted/40')}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
